const navbarMenuConfigs = [
  {
    title: "کارمزدها",
    link: "/commissions",
  },
  {
    title: "راهنمای استفاده",
    link: "/guide",
  },
  {
    title: "قوانین",
    link: "/terms-and-conditions",
  },
  {
    title: "درباره‌ها",
    link: "/about-us",
  },
  {
    title: "بلاگ",
    link: "/",
  },
  {
    title: "تماس با ما",
    link: "/contact-us",
  },
];

export default navbarMenuConfigs;
